
import { mapGetters, mapActions } from "vuex";
let default_customer_data = {
	_id 				: null,
	email				: '',
	first_name			: '',
	last_name			: '',
	phone				: '',
	address				: {
		first_name	: '',
		last_name	: '',
		name		: '',
		phone		: '',
		address_1	: '',
		address_2	: '',
		company		: '',
		country		: 'Mexico',
		country_code: 'MX',
		state		: 'Aguascalientes',
		state_code	: 'AGS',
		city		: '',
		zip			: ''
	},
	password				: '',
	password_confirmation	: '',
	business_type			: null,
	terms_and_conditions	: true,
	contact_language		: '624366d24f8c4efe2aa251b1'
};
export default {
	props		: ['initialState'],
	components	:{
		vcLoading	: () => import('../../components/pages/loading.vue' ),
		formAddress	: () => import('../../components/pages/form-address.vue'),
		formBusiness: () => import('../../components/account/form-business.vue'),
		vcFormField	: () => import('../../components/pages/form-field.vue')
	},
	data() {
		return {
			isLoadingForm			: true,
			stepError				: false,
			
			listCountries			: [],
			listPhoneCodes			: [],
			listStates				: [],
			addressForm				: {...default_customer_data.address, email: ''},
			default_customer		: {...default_customer_data},
			new_customer			: {...default_customer_data},
			agent					: null,
			profile_image			: null,
			hide_profile 			: false,
			
			optionPhoneCodes		: [],
			
			dataCountries			: [],
			optionAddressCountries	: [],
			optionAddressStates		: [],
			translate_languages		: [],
			
			db_country				: null,
			db_state				: null,
			options_business_type 	: [],
			contact_language		: '624366d24f8c4efe2aa251b1',
			step_data				: null
		};
	},
	async mounted() {
		const browserLanguage = navigator.language || navigator.languages[0];
		// console.log('Browser Language:', browserLanguage);
		
		this.options_business_type = this.getterBusinessTypes.map((item) => {
			return { label: item.name, id: item._id.toString() };
		});
		this.default_customer.business_type = this.options_business_type[0].id;
		this.new_customer = {...this.default_customer};
		await this.getCountries().then( async (result_countries) => {
			
			this.listPhoneCodes = this.getterCountries.phone_codes;
			this.listCountries 	= this.getterCountries.list;
			this.listStates     = this.getterCountries.states;
			
			this.isLoadingForm 	= null;
		}); 
		this.$root.$on('valid-form-address', this.validFormAddress);
		this.$root.$on('update-field-value', this.updateFieldValue);
		
		this.translate_languages = this.getterTranslates.components.pages.form_field.contact_language.options.map( (item) => {
			
			let exist_language = this.getterNewCustomerLanguages.find( (item_language) => item_language.label === item.label['en_US'] );
			
			return { label: item.label, value: exist_language ? exist_language.value : null };
		});
		
	},
	computed	: {
		...mapGetters({
			getterTranslates			: 'getterTranslates',
			getterStoreLang				: 'getterStoreLang',
			getterBasicData 			: 'getterBasicData',
			getterNewCustomer			: 'getterNewCustomer',
			getterCountries				: 'getterCountries',
			getterBusinessTypes			: 'getterBusinessTypes',
			getterNewCustomerLanguages	: 'getterNewCustomerLanguages'
		}),
		getLoadingForm(){
			return this.isLoadingForm;
		},
		getCustomerAddress(){
			return this.addressForm;
		},
		getDataListCountries(){
			return this.listCountries;
		},
		getDataListStates(){
			return this.listStates;
		},
		getDataListPhoneCodes(){
			return this.listPhoneCodes;
		},
		getAgent(){
			return this.agent;
		},
		getCompanyPhoneNumberCall(){
			return this.getterBasicData?.contact_information.phones.find( (item) => item.call ) || null;
		},
		getCompanyPhoneNumberWhatsapp(){
			return this.getterBasicData?.contact_information.phones.find( (item) => item.whatsapp ) || null;
		},
		getCompanyPhoneNumberSMS(){
			return this.getterBasicData?.contact_information.phones.find( (item) => item.sms ) || null;
		},
		getContactLanguage(){
			return this.contact_language;
		}
	},
	methods		: {
		...mapActions({
			getCountries	: 'getCountries',
			addNotification	: 'addNotification',
			createCustomer	: 'createCustomer',
			addNotification	: 'addNotification'
		}),
		async validFormAddress(data_form){
			
			this.step_data = data_form;
			document.getElementById('submit-form-step-1').click();
		},
		async preSubmitSetp(is_valid){
			
			if( this.step_data.valid && this.step_data.valid_zip_code ){
				
				try {
					
					const token = await this.$recaptcha.getResponse();
					console.log( token );
					if( token ){
						
						this.addressForm    	= this.step_data.address;
						
						this.new_customer.email 		= this.addressForm.email;
						this.new_customer.first_name 	= this.addressForm.first_name;
						this.new_customer.last_name 	= this.addressForm.last_name;
						this.new_customer.address.name 	= `${ this.new_customer.first_name } ${ this.new_customer.last_name }`;
						this.new_customer.phone 		= this.addressForm.phone.format;
						
						let data_customer 		= {
							first_name		: this.new_customer.first_name,
							last_name		: this.new_customer.last_name,
							email			: this.new_customer.email,
							phone			: this.new_customer.phone,
							password		: this.new_customer.password,
							address			: null,
							type_business	: this.new_customer.business_type,
							idGoogleAdd		: this.$cookies.get('gclid') 		? this.$cookies.get('gclid').value 	: null,
							origin			: this.$cookies.get('origin_add') 	? this.$cookies.get('origin_add') 	: null,
							utmSource		: this.$cookies.get('utmSource') 	? this.$cookies.get('utmSource') 	: null,
							utmMedium		: this.$cookies.get('utmMedium') 	? this.$cookies.get('utmMedium') 	: null,
							utmCampaign		: this.$cookies.get('utmCampaign') 	? this.$cookies.get('utmCampaign') 	: null,
							utmTerm			: this.$cookies.get('utmTerm') 		? this.$cookies.get('utmTerm') 		: null,
							source			: this.initialState.source,
							language		: this.getContactLanguage,
							note			: `${ this.addressForm.state } (${ this.addressForm.state_code }), ${ this.addressForm.city }`,
							client_ip		: null
						};
						this.agent 			= null;
						this.isLoadingForm 	= true;
						await this.createCustomer(data_customer).then( (result_customer) => {
							
							this.stepError 		= false;
							this.isLoadingForm 	= null;
							if( this.getterNewCustomer.valid ){
								
								this.new_customer 	= {...this.default_customer};
								this.agent 			= this.getterNewCustomer.data?.agent || null;
								if( this.agent != null ){
									
									this.profile_image 		= ( this.agent === null || this.agent.photo === '' ) ? `${ this.$config.hefesto_file.baseURL }/images/svg-store/svg-profile-image/svg-secondary.svg` : `${ this.$config.agent.baseURL.replace('/api', '') }/${ this.agent.photo.replace('public/', '') }`;
									this.hide_profile 		= false;
									this.agent.phone 		= !['', null].includes(this.agent.phone) ? this.agent.phone : null;
									this.agent.whatsappLink = this.agent.phone != null ? `https://api.whatsapp.com/send?phone=${ this.agent.phone.replace(/ +/g, '').replace('+', '') }` : null;
									this.agent.smsLink 		= this.agent.phone != null ? `sms:${ this.agent.phone.replace(/ +/g, '') }?body=${ encodeURI( this.getterTranslates.components.account.step_register.modal_create.agent.sms_message[this.getterStoreLang] ) }` : null;
								}
								this.showModal('modal_agent');
								this.$root.$emit('reset-address', { id_form: 'register-customer-address', clean: true });
								
								this.$cookies.remove('gclid');
								this.$cookies.remove('origin_add'); 
								this.$cookies.remove('utmSource'); 
								this.$cookies.remove('utmMedium');
								this.$cookies.remove('utmCampaign');
								this.$cookies.remove('utmTerm');
							}
						});
					}
				} catch (error) {
					
					this.stepError = true;
					this.addNotification({ 
						content	: { type: 'request' }, 
						type	: 'error', 
						data	: {
							title		: `Error: reCAPTCHA Validation`, 
							message		: `reCAPTCHA could not be validated correctly, please try again`,
							app_version	: this.$cookies.get('app-version')
						}
					});
				}
			}
			else{
				
				this.addNotification({ 
					content	: { type: 'request' }, 
					type	: 'error', 
					data	: { 
						title		: 'Error: Register fields', 
						message		: `There are fields that have not been validated`, 
						app_version	: this.$cookies.get('app-version') 
					}
				});
			}
		},
		updateFieldValue(data){
			
			console.log( data, this.new_customer, !!this.new_customer[data.field], this.new_customer[data.field] );
			this.new_customer[data.field] = data.value;
		},
		stepNumberClasses() {
			
			return !this.stepError ? 'step-orange text-white' : 'step-error text-white';
		},
		goNextStep() {
			
			this.$root.$emit('valid-address', { id_form: 'register-customer-address', action: 'register-customer-address' });
		},
		showModal(refName) {
			
			this.$refs[refName].show();
		},
		hideModal(refName) {
			
			this.$refs[refName].hide();
		}
	}
};
